import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Navbar() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="container-fluid border-bottom mt-2 pb-2">
        <div className="row">
          <div className="col">
            <div className="d-flex align-items-center gap-4">
              
              <div className="d-flex gap-2 align-items-center lh-0 d-none d-md-block">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-clock-history" viewBox="0 0 16 16">
                    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022z"/>
                  </svg>
                </span>
                <span className="fs-6 fw-medium"> Time: Mon-Fri 9:00-16:00</span>
              </div>

              <div className="d-flex gap-2 align-items-center lh-0">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-telephone-forward" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063z"/>
                  </svg>
                </span>
                <span className="fs-6 fw-medium"> +234 906 216 8062</span>
              </div>

            </div>
          </div>

          <div className="col-auto">
            <div className="d-flex align-items-center gap-4">
              <div className="d-flex gap-2 align-items-center lh-0 d-none d-md-block">
                <a href="mailto:admin@ebunheritageschool.com" className="text-inherit fs-5 fw-medium">
                  admin@ebunheritageschool.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid px-0">

          <Link className="navbar-brand me-lg-8" to="/">
            <img src="./assets/images/brand/logo/logo.png" width={80} alt="Logo" />
            <span className="text-dark fs-3 fw-medium">Ebun Heritage Schools</span>
          </Link>

          {/* Right Buttons */}
          <div className="me-lg-8 d-flex align-items-center order-lg-3">
            <div className="gap-3 d-none d-lg-flex">
              <a href="/student" className="btn btn-outline-dark rounded-3">Student App</a>
              <Link to="/entrance" className="btn btn-dark rounded-3">Online Entrance</Link>
            </div>
          </div>

          {/* Mobile Toggle */}
          <div>
            <button
              class="navbar-toggler collapsed ms-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation">
              <span class="icon-bar top-bar mt-0"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>
          </div>

          {/* Menu */}
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav mt-3 mt-lg-0 ms-lg-8">

              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>

              {/* The School Dropdown */}
              <li className="nav-item dropdown">
                <a
                  href="#"
                  className="nav-link dropdown-toggle"
                  id="navbarSchool"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  The School
                </a>

                <div className="dropdown-menu px-lg-8" aria-labelledby="navbarSchool">
                  <div className="d-flex mt-4 mb-4">

                    <div>
                      <div className="mb-3">
                        <div className="fs-4 fw-medium text-dark">Get Started</div>
                      </div>
                      <Link className="dropdown-item" to="/about">About Us</Link>
                      <Link className="dropdown-item" to="/management">Management Team</Link>
                      <Link className="dropdown-item" to="/chairman">PTF Chairman’s Welcome</Link>
                      <Link className="dropdown-item" to="/entrance">
                        Entrance Form <span className="badge">new</span>
                      </Link>
                    </div>

                    <div className="d-flex ms-lg-8 me-lg-8" style={{ height: "250px" }}>
                      <div className="vr"></div>
                    </div>

                    <div>
                      <div className="mb-3">
                        <div className="fs-4 fw-medium text-dark">Education</div>
                      </div>
                      <Link className="dropdown-item" to="/creche">Creche & Pre-school</Link>
                      <Link className="dropdown-item" to="/elementary">Primary School</Link>
                      <Link className="dropdown-item" to="/secondary">Secondary School</Link>
                      <Link className="dropdown-item" to="/special">Special Need School</Link>
                      <Link className="dropdown-item" to="/extracurricular">Extracurricular Activities</Link>
                    </div>

                  </div>
                </div>
              </li>

              {/* More Info Dropdown */}
              <li className="nav-item dropdown">
                <a
                  href="#"
                  className="nav-link dropdown-toggle"
                  id="navbarMore"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  More Information
                </a>

                <ul className="dropdown-menu" aria-labelledby="navbarMore">
                  <li><Link className="dropdown-item" to="/gallery">Image Gallery</Link></li>
                  <li><Link className="dropdown-item" to="/admissions">Admissions</Link></li>
                  <li><Link className="dropdown-item" to="/alumni">Alumni</Link></li>
                  <li><Link className="dropdown-item" to="/careers">Careers</Link></li>
                  <li><Link className="dropdown-item" to="/privacy-policy">Privacy Policy</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">Contact Us</Link>
              </li>

              <li className="nav-item">
              <div className="gap-3 d-flex d-lg-none mt-2">
                <a href="/student" className="btn btn-outline-dark rounded-3">Student App</a>
                <Link to="/entrance" className="btn btn-dark rounded-3">Online Entrance</Link>
              </div>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
